export default __webpack_public_path__ + "static/media/chat-face0.e171d87d.png";